var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.83073H1.5M12.3333 1.16406V4.4974M5.66667 1.16406V4.4974M5.5 17.8307H12.5C13.9001 17.8307 14.6002 17.8307 15.135 17.5582C15.6054 17.3186 15.9878 16.9361 16.2275 16.4657C16.5 15.9309 16.5 15.2309 16.5 13.8307V6.83073C16.5 5.4306 16.5 4.73053 16.2275 4.19575C15.9878 3.72535 15.6054 3.3429 15.135 3.10321C14.6002 2.83073 13.9001 2.83073 12.5 2.83073H5.5C4.09987 2.83073 3.3998 2.83073 2.86502 3.10321C2.39462 3.3429 2.01217 3.72535 1.77248 4.19575C1.5 4.73053 1.5 5.4306 1.5 6.83073V13.8307C1.5 15.2309 1.5 15.9309 1.77248 16.4657C2.01217 16.9361 2.39462 17.3186 2.86502 17.5582C3.3998 17.8307 4.09987 17.8307 5.5 17.8307Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.46ae89d28c78ff3b0bd9a135774638b7.svg";
export { ForwardRef as ReactComponent };